const css = `.uGB0fW__underline{border-bottom:1px solid;line-height:20px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"underline":"uGB0fW__underline"};
